module.exports = __webpack_public_path__ + "static/media/water-dashboard.e72ca327.svg";